module.exports = __webpack_public_path__ + "img/27.9ea38919.png";